/**
 * @generated SignedSource<<6b63100191ffc4f015efc623fdc4b111>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DenyAllRespondentsInput = {
  clientMutationId?: string | null;
  countToSelect?: number | null;
  excludeIds?: ReadonlyArray<string | null> | null;
  filterComplex?: any | null;
  studyId: string;
  tab?: string | null;
};
export type ParticipantsBatchMutations_DenyAllRespondents_Mutation$variables = {
  input: DenyAllRespondentsInput;
};
export type ParticipantsBatchMutations_DenyAllRespondents_Mutation$data = {
  readonly denyAllRespondents: {
    readonly study: {
      readonly id: string;
      readonly needsReviewCount: number | null;
      readonly rejectedCount: number | null;
    } | null;
  } | null;
};
export type ParticipantsBatchMutations_DenyAllRespondents_Mutation = {
  response: ParticipantsBatchMutations_DenyAllRespondents_Mutation$data;
  variables: ParticipantsBatchMutations_DenyAllRespondents_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DenyAllRespondentsPayload",
    "kind": "LinkedField",
    "name": "denyAllRespondents",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StudyNode",
        "kind": "LinkedField",
        "name": "study",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "needsReviewCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rejectedCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ParticipantsBatchMutations_DenyAllRespondents_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ParticipantsBatchMutations_DenyAllRespondents_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "350f6e4d2d48eeeb7548ea84b26f319b",
    "id": null,
    "metadata": {},
    "name": "ParticipantsBatchMutations_DenyAllRespondents_Mutation",
    "operationKind": "mutation",
    "text": "mutation ParticipantsBatchMutations_DenyAllRespondents_Mutation(\n  $input: DenyAllRespondentsInput!\n) {\n  denyAllRespondents(input: $input) {\n    study {\n      id\n      needsReviewCount\n      rejectedCount\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8a93c12a96e74952977d71a58b641430";

export default node;
